module.exports = __webpack_public_path__ + "static/mixed-33abc24d230810a1c98e1d271e84571e.jpg";